import { render, staticRenderFns } from "./VariantSifterCredibleSetsDrawer.vue?vue&type=template&id=01a9927a&scoped=true&"
import script from "./VariantSifterCredibleSetsDrawer.vue?vue&type=script&lang=js&"
export * from "./VariantSifterCredibleSetsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterCredibleSetsDrawer.vue?vue&type=style&index=0&id=01a9927a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a9927a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01a9927a')) {
      api.createRecord('01a9927a', component.options)
    } else {
      api.reload('01a9927a', component.options)
    }
    module.hot.accept("./VariantSifterCredibleSetsDrawer.vue?vue&type=template&id=01a9927a&scoped=true&", function () {
      api.rerender('01a9927a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterCredibleSetsDrawer.vue"
export default component.exports